import type { SceneNode } from "../scene/model";
import { nodeMatrix } from "../native/transforms";
/** Integer document translation preserves the existing raster's sampling phase. */
export function rasterTranslation(before: SceneNode, after: SceneNode) {
  if (
    before.kind !== after.kind ||
    before.layer.clipToBelow ||
    after.layer.clipToBelow ||
    before.geometry !== after.geometry ||
    before.appearance !== after.appearance ||
    before.text !== after.text ||
    before.effects !== after.effects ||
    before.interaction !== after.interaction ||
    before.media !== after.media
  )
    return null;
  const a = nodeMatrix(before),
    b = nodeMatrix(after);
  if (a.slice(0, 4).some((value, i) => value !== b[i])) return null;
  const x = b[4] - a[4],
    y = b[5] - a[5];
  return Number.isInteger(x) && Number.isInteger(y) ? { x, y } : null;
}
